// src/components/product/Product.jsx
import React from "react";
import { BsSuitHeartFill } from "react-icons/bs";
import { GiReturnArrow } from "react-icons/gi";
import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import { formatPrice } from "../../../constants/funciones";
import { useFavorites } from "../../../context/FavoritesContext";

const Product = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { favorites, toggleFavorite } = useFavorites();

  const idString = (name) =>
    String(name).toLowerCase().replace(/\s+/g, "").replace(/[^\w-]/g, "");

  const rootId = idString(props.Descripcion);
  const isFavorite = favorites.some((f) => f.codigo === props.codigo);

  const handleProductDetails = () => {
    navigate(`/product/${rootId}`, { state: { item: props } });
  };

  return (
    <div className="w-full relative group border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
      {/* Imagen con click al detalle */}
      <div
        className="w-full relative overflow-hidden cursor-pointer"
        onClick={handleProductDetails}
      >
        <Image className="w-full h-64 object-cover" imgSrc={props.img} />

        <div className="absolute bottom-0 w-full bg-white transition-transform duration-700 transform translate-y-full group-hover:translate-y-0">
          <ul className="flex flex-col gap-2 font-titleFont px-2">
            <li className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300">
              Compartir
              <GiReturnArrow />
            </li>

            <li
              onClick={(e) => {
                e.stopPropagation();
                dispatch(addToCart({ ...props, quantity: 1 }));
              }}
              className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300"
            >
              Agregar al Carrito
              <FaShoppingCart />
            </li>

            <li
              onClick={(e) => {
                e.stopPropagation();
                handleProductDetails();
              }}
              className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300"
            >
              Ver Detalles
              <MdOutlineLabelImportant className="text-lg" />
            </li>

            <li
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(props);
              }}
              className={`text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300 ${isFavorite ? "text-green-500" : "text-[#767676]"
                }`}
            >
              {isFavorite ? "Eliminar de Favoritos" : "Agregar a Favoritos"}
              <BsSuitHeartFill />
            </li>
          </ul>
        </div>
      </div>

      {/* Info del producto */}
      <div
        className="border-t border-gray-200 px-4 py-4 flex flex-col cursor-pointer transition-opacity duration-300 hover:opacity-10"
        onClick={handleProductDetails}
      >
        <div className="text-sm">Código: {props.codigo}</div>

        <div
          className="text-lg font-bold text-primeColor leading-tight"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "3rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          {props.Descripcion}
        </div>

        <div className="text-sm">
          {props.PrecioOferta > 0 ? (
            <>
              <span className="line-through mr-1">
                ${formatPrice(props.PrecioLista)}
              </span>
              <span>${formatPrice(props.PrecioOferta)}</span>
            </>
          ) : (
            `$${formatPrice(props.PrecioLista)}`
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
